import { IonIcon } from '@ionic/react';
import React from 'react';
import HtmlParseComponent from '../../../pages/Menu/htmlParsingComponent';
import './notification.scss';

const Notification = (props: any) => {
  const { contentStackData } = props;

  const handleClose = () => {
    props.close && props.close(false);
  };

  return (
    <>
      {contentStackData ? (
        <div className="sni-notifcation-wrapper">
          <div className="notification-inner">
            {contentStackData.image && contentStackData.image.url && (
              <img className="notification-logo" src={contentStackData.image.url} alt="" />
            )}
            <div>
              <h4>{contentStackData.title}</h4> <HtmlParseComponent richText={contentStackData.description} isRichText={false} /> <a href={contentStackData.linkHref} target="_blank">{contentStackData.linkTitle}</a>
            </div>
          </div>
          <IonIcon className="close-icon" src="./assets/icon/close-white.svg" onClick={handleClose} />
        </div>
      ) : null}
    </>    
  );
};

export default Notification;
